import ClientUserActionTypes from './clientuser.types';

const INITIAL_STATE = {
  clientusers: []
};

const clientUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ClientUserActionTypes.SET_CLIENT_USERS:
      return {
        ...state,
        clientusers: action.payload
      };
    default:
      return state;
  }
};

export default clientUserReducer;
